
import PY from "country-flag-icons/3x2/PY.svg";

const flags = { PY };

export function getFlag(language) {
  return flags[language];
}
